'use client';

import '@mantine/core/styles.layer.css';

import { MantineProvider as MantineProviderBase } from '@mantine/core';
import { ReactNode } from 'react';

import { mantineTheme } from '@/theme';

interface MantineProviderProps {
  children: ReactNode;
}

export const MantineProvider = ({ children }: MantineProviderProps) => {
  return (
    <MantineProviderBase theme={mantineTheme}>{children}</MantineProviderBase>
  );
};
